var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-navigation"},[(_vm.$mq !== 'mobile')?_c('header-overview-link',{staticClass:"overview-link"}):_vm._e(),_c('header-children')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }